import React, { Fragment, useState } from "react";
import "../Reporting.css";
import ReportingModals from "../../../../shared/Modals/ReportingModals";
import arrowImg from "../../../../assets/purple.svg";

const DoctorPerformance = (props) => {
  const [lgShow, setLgShow] = useState(false);

  return (
    <Fragment>
      <div
        onClick={(e) => {
          props?.check ? setLgShow(true) : e.preventDefault();
        }}
        className=""
      >
        <span className="patient_style">
          Doctor Performance
          <img src={arrowImg} alt="" className="arrow-img ml-2" />
        </span>
      </div>
      <div
        onClick={(e) => {
          props?.check ? setLgShow(true) : e.preventDefault();
        }}
        id={props?.divId}
      ></div>
      {setLgShow ? (
        <ReportingModals
          setLgShow={setLgShow}
          lgShow={lgShow}
          show={3}
          title={"Doctor Performance"}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
};
export default DoctorPerformance;